export function pluralClasses(n: number): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return 'класс';
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 'класса';
  return 'классов';
}

export function affordableLabel(count: number | null): string | null {
  if (count === null) return null;
  if (count <= 0) return 'Не хватает на класс';
  return `Хватит на ${count} ${pluralClasses(count)}`;
}
